import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import PropTypes from 'prop-types';

import './style.scss';

export default function RangeSlider(props) {
	const { range, min, max, defaultValue, onChange, value, label } = props;
	return (
		<>
			{label && <label className='slider__label '>{label}</label>}
			<div className='slider column-center'>
				<div className='slider__value'>
					<span>{value?.at() || min}</span>
					<span>{value?.at(1) || max}</span>
				</div>
				<div className='slider__container'>
					<Slider
						range={range}
						allowCross={false}
						min={min}
						max={max}
						value={value}
						defaultValue={defaultValue}
						trackStyle={{ backgroundColor: 'var(--text-on-primary)' }}
						handleStyle={{ borderColor: 'var(--primary)' }}
						onChange={onChange}
					/>
				</div>
			</div>
		</>
	);
}

RangeSlider.propTypes = {
	range: PropTypes.bool,
	allowCross: PropTypes.bool,
	min: PropTypes.number,
	max: PropTypes.number,
	defaultValue: PropTypes.array,
	onChange: PropTypes.func,
	value: PropTypes.array
};

RangeSlider.defaultProps = {
	range: true,
	allowCross: false,
	min: 0,
	max: 2000,
	defaultValue: [],
	value: [],
	onChange: () => {}
};
